import { useEffect } from 'react';
import { useDiagnosticLogging } from '@/hooks/use-diagnostic-logging';
import * as ActivityLogger from '@/lib/activity-logger';
import logger from '@/lib/logging';

/**
 * DiagnosticLogMonitor — enables background diagnostic capture when app-wide setting is on.
 * Does NOT start recording or affect the Feedback button.
 * Recording is exclusively user-triggered via the Feedback button.
 */
export function DiagnosticLogMonitor() {
  const { isEnabled } = useDiagnosticLogging();

  useEffect(() => {
    ActivityLogger.setDiagnosticCaptureEnabled(isEnabled);
    if (isEnabled) {
      logger.info('🛡️ [DiagnosticLogMonitor] Background diagnostic capture enabled. Logs stored locally and flushed periodically.');
    }
    return () => {
      ActivityLogger.setDiagnosticCaptureEnabled(false);
    };
  }, [isEnabled]);

  return null;
}
